import axios from 'axios'
import { load_many, load_one } from '@/store/action-helpers'

export default {

    create({ dispatch }, { model }) {
        return axios.post(`/api/v1/shipping-addresses`, model).then(response => {

            return Promise.all([
                dispatch('loadOne', { id: response.data.id }),
                dispatch('products/loadOne', { id: model.product, force: true }, { root: true }),
            ])
        })
    },

    loadOne: load_one('shipping-addresses/:id'),
    loadAllByProductId: load_many('products/:productId/shipping-addresses'),

    remove({ dispatch }, { model }) {
        return axios.delete(`/api/v1/shipping-addresses/${model.id}`).then(() => {
            return dispatch('products/loadOne', { id: model.product, force: true }, { root: true })
        })
    },

    update({ dispatch }, { model }) {
        return axios.put(`/api/v1/shipping-addresses/${model.id}`, model).then(() => {
            return dispatch('loadOne', { id: model.id, force: true })
        })
    },

}
